module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C841"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("SEROTONIN")])])]), _vm._v(" "), _c('p', {
    staticClass: "C852"
  }, [_vm._v("Afterward he would ask her")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("what color she saw, what hue")]), _vm._v(" "), _c('p', {
    staticClass: "C862"
  }, [_vm._v(".   .   .")]), _vm._v(" "), _c('p', {
    staticClass: "C864"
  }, [_vm._v("of red if she’d come violently")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("or green if she’d eased herself down")]), _vm._v(" "), _c('p', {
    staticClass: "C862"
  }, [_vm._v(".   .   .")]), _vm._v(" "), _c('p', {
    staticClass: "C864"
  }, [_vm._v("into that limitless trove")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("of ecstasies. She’d climb off,")]), _vm._v(" "), _c('p', {
    staticClass: "C862"
  }, [_vm._v(".   .   .")]), _vm._v(" "), _c('p', {
    staticClass: "C864"
  }, [_vm._v("his spent member sliding out")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("(needle from vein?) and sprawl back")]), _vm._v(" "), _c('p', {
    staticClass: "C862"
  }, [_vm._v(".   .   .")]), _vm._v(" "), _c('p', {
    staticClass: "C864"
  }, [_vm._v("with her hands over her eyes:")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("I saw white, just white, apples")]), _vm._v(" "), _c('p', {
    staticClass: "C862"
  }, [_vm._v(".   .   .")]), _vm._v(" "), _c('p', {
    staticClass: "C864"
  }, [_vm._v("sliced open, white of moths around")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("a lamp, my mother’s bath towels")]), _vm._v(" "), _c('p', {
    staticClass: "C862"
  }, [_vm._v(".   .   .")]), _vm._v(" "), _c('p', {
    staticClass: "C864"
  }, [_vm._v("folded on a bed. "), _c('em', [_vm._v("And you?")])]), _vm._v(" "), _c('p', {
    staticClass: "C862"
  }, [_vm._v(".   .   .")]), _vm._v(" "), _c('p', {
    staticClass: "C864"
  }, [_vm._v("Trout-stirred silt in the clear spring’s cress,")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("the wide meadowstream canopied")]), _vm._v(" "), _c('p', {
    staticClass: "C862"
  }, [_vm._v(".   .   .")]), _vm._v(" "), _c('p', {
    staticClass: "C864"
  }, [_c('span', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("by")]), _vm._v(" May cottonwoods’ full bloom—")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("not color so much, then, but")]), _vm._v(" "), _c('p', {
    staticClass: "C862"
  }, [_vm._v(".   .   .")]), _vm._v(" "), _c('p', {
    staticClass: "C864"
  }, [_vm._v("a place of vacancy color")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("might inhabit: what the eyes looked like")]), _vm._v(" "), _c('p', {
    staticClass: "C862"
  }, [_vm._v(".   .   .")]), _vm._v(" "), _c('p', {
    staticClass: "C864"
  }, [_vm._v("before the irises formed,")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("the river held in cupped hands—")]), _vm._v(" "), _c('p', {
    staticClass: "C862"
  }, [_vm._v(".   .   .")]), _vm._v(" "), _c('p', {
    staticClass: "C864"
  }, [_vm._v("he might have been sleeping by now,")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("she might have wondered if this time")]), _vm._v(" "), _c('p', {
    staticClass: "C862"
  }, [_vm._v(".   .   .")]), _vm._v(" "), _c('p', {
    staticClass: "C864"
  }, [_vm._v("she would conceive. They would fall")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("further apart (privacy")]), _vm._v(" "), _c('p', {
    staticClass: "C862"
  }, [_vm._v(".   .   .")]), _vm._v(" "), _c('p', {
    staticClass: "C864"
  }, [_vm._v("of dreams deeper than privacy")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("of reveries) before dawn’s wash")]), _vm._v(" "), _c('p', {
    staticClass: "C862"
  }, [_vm._v(".   .   .")]), _vm._v(" "), _c('p', {
    staticClass: "C864"
  }, [_vm._v("turned indigo the sky above")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("the cobalt mountains, and she")]), _vm._v(" "), _c('p', {
    staticClass: "C862"
  }, [_vm._v(".   .   .")]), _vm._v(" "), _c('p', {
    staticClass: "C864"
  }, [_vm._v("would draw her hand along the line")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("day had drawn: the same motion")]), _vm._v(" "), _c('p', {
    staticClass: "C862"
  }, [_vm._v(".   .   .")]), _vm._v(" "), _c('p', {
    staticClass: "C864"
  }, [_vm._v("the womb-child would months later")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("make against her inner-skin,")]), _vm._v(" "), _c('p', {
    staticClass: "C862"
  }, [_c('span', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v(".   .   .")])]), _vm._v(" "), _c('p', {
    staticClass: "C864"
  }, [_vm._v("little ingot, squinting at")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("a pale glow just beyond its reach.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99984fe8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/09_Serotoni.vue
// module id = 81
// module chunks = 0